module.exports = __webpack_public_path__ + "images/square-30-68c9c1333acc4ea715969c6c631adafd.jpg";